import {BrowserRouter, Routes, Route} from "react-router-dom";
import Login from "./pages/Login/Login";
import Systems from "./pages/Systems/Systems";
import Branches from "./pages/Branches/Branches";
import Layout from "./layout/Layout";
import BrenchUsers from "./pages/BranchUsers/BranchUsers"
import Dashboard from "./pages/Dashboard/Dashboard";
import StaffAttendance from "./pages/StaffAttendance/StaffAttendance";
import StudentAttendance from "./pages/StudentAttendance/StudentAttendance";
import UserDetail from "./pages/UserDetail/UserDetail"
import WorkingHours from "./pages/WorkingHours/WorkingHours"
export default function App() {
    return (
        <BrowserRouter>
            <Routes>

                <Route path="/" element={<Login/>}/>
                <Route path="/systems" element={<Systems/>}/>
                <Route path="/branches/:systemId" element={<Branches/>}/>

                <Route element={<Layout/>}>
                    <Route path="/brench_users" element={<BrenchUsers/>}/>
                    <Route path="/dashboard" element={<Dashboard/>}/>
                    <Route path="/staff" element={<StaffAttendance/>}/>
                    <Route path="/students" element={<StudentAttendance/>}/>
                    <Route path="/user/:id" element={<UserDetail />} />
                    <Route path="/working_hours" element={<WorkingHours />} />
                </Route>

            </Routes>
        </BrowserRouter>
    );
}
